module.exports = __webpack_public_path__ + "static/media/img-horizontal-unemployment@2x.173fb37d.png";